import { request } from './base.service';

export type AccountType = 'cash' | 'credit';

export interface Account {
    id: string;
    userID: string;
    name: string;
    type: AccountType;
    balance: number;
    limit?: number;
    currency: string;
    active: boolean;
}

export interface AccountInput {
    name: string;
    type: AccountType;
    balance: number;
    limit?: number;
    currency: string;
}

export const getAccounts = (userid: string): Promise<Account[]> =>
    request(`/accounts/${userid}`).then((d) => {
        if (Array.isArray(d)) return d;
        if (d && Array.isArray(d.accounts)) return d.accounts;
        return [];
    });

export const getAccountsTotal = (userid: string): Promise<{ total: number }> =>
    request(`/accounts/${userid}/total`);

export const createAccount = (userid: string, account: AccountInput): Promise<Account> =>
    request(`/accounts/${userid}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(account),
    });

export const updateAccount = (userid: string, id: string, account: AccountInput): Promise<Account> =>
    request(`/accounts/${userid}/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(account),
    });

export const deleteAccount = (userid: string, id: string): Promise<Account> =>
    request(`/accounts/${userid}/${id}`, { method: 'DELETE' });
